export interface IThreeDSecureProviderAutomatedForceOnBoardingResponse {
  forceOnBoarding: string;
}
